import { Tooltip } from 'antd';
import { formatSecondsRange } from '@/utils/format';

interface SecondsRangeProps {
  /** Half-open `[lower, upper)` second offsets. */
  value: { lower: number; upper: number };
  /** Extra line under the raw values in the tooltip. */
  hint?: string;
  /** Hides the covered length in parentheses. */
  withoutLength?: boolean;
}

/**
 * Second offsets as clock times plus the covered length; the raw values stay
 * one hover away.
 */
export const SecondsRange = ({
  value,
  hint,
  withoutLength,
}: SecondsRangeProps) => (
  <Tooltip
    title={
      <>
        <div>{`[${value.lower}, ${value.upper}) s`}</div>
        {hint && <div>{hint}</div>}
      </>
    }
  >
    <span>{formatSecondsRange(value, { withoutLength })}</span>
  </Tooltip>
);
